import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, RelateStatementStepData } from '@packages/shared/core/quiz/entities';

type RelateStatementQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const RelateStatementQuizStep = ({ id, renderQuizScreen }: RelateStatementQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as RelateStatementStepData;

  const goBack = async () => back();

  const onChosen = async (text: string, key?: string) => {
    updateUserPreferences(dataKey, text.toLowerCase());
    await next(text, key);
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        totalSteps,
        stepOrder,
        ...(stepData as RelateStatementStepData),
      })}
    </>
  );
};

export default RelateStatementQuizStep;
